import React from 'react';
import { LockIcon, DownloadIcon, ShieldCheckIcon, FileTextIcon } from 'lucide-react';
type TrustRowProps = {
  tone?: 'light' | 'dark';
  className?: string;
};
const items = [{
  icon: LockIcon,
  label: 'Secure checkout'
}, {
  icon: DownloadIcon,
  label: 'Instant download'
}, {
  icon: ShieldCheckIcon,
  label: '7-day keep-the-files guarantee'
}, {
  icon: FileTextIcon,
  label: '100% digital (PDF)'
}];
export function TrustRow({
  tone = 'light',
  className = ''
}: TrustRowProps) {
  const color = tone === 'dark' ? 'text-white/60' : 'text-ink-muted';
  return <ul className={`flex flex-wrap items-center gap-x-4 gap-y-2 text-[12px] font-medium ${color} ${className}`} data-id="element-270" data-mp="1yxzsxvbwtp01">
      {items.map(({
      icon: Icon,
      label
    }) => <li key={label} className="inline-flex items-center gap-1.5" data-id="element-271" data-mp="1txlkic6ecd1h">
          <Icon className="h-3.5 w-3.5 shrink-0" strokeWidth={1.75} aria-hidden="true" data-id="element-272" data-mp="3ac3np3qbnh65" />
          <span data-id="element-273" data-mp="35ev0goqbgmy1">{label}</span>
        </li>)}
    </ul>;
}